<template>
  <!-- <Table :value="List" :paginator="false" class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu"
        responsiveLayout="scroll" :columns="headers" dataKey="Id" :globalFilterFields="globalFilterFields"
        :filters="filters" selectionMode="single" scrollable scrollHeight="400px"> </Table> -->
  <!-- {{ List }} -->
  <Table
    :rowHover="true"
    filterDisplay="menu"
    responsiveLayout="scroll"
    :footerVisible="true"
    :columns="headers"
    v-model:value="processedData"
    :normaltablesearch="normaltablesearch"
    class="mt-5"
  >
    <template v-slot:HSNCode="{ data }">
      {{ data.HSNCode != "0" ? data.HSNCode : "" }}
    </template>
    <template v-slot:Footer="{ data }">
      <div class="p-datatable-tfoot">
        <div class="p-datatable-columns">
          <b-row>
            <b-col>
              {{ $t("grn.overallItemtax") }}
            </b-col>
            <b-col></b-col>
            <b-col>
              <p class="ps-2">{{ sum(List).toFixed(2) }}</p>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </Table>
  <!-- <span>OverAll Tax {{ OverAllTax }}</span> -->
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  watch,
  computed,
} from "vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import InputNumber from "../../../../../components/FormComponents/InputNumber.vue";
import Table from "../../../../../components/FormComponents/NormalTable.vue";
import commonservice from "../../../../../modules/Inventory/Service/StoreService";
import { FilterMatchMode } from "primevue/api";

export default defineComponent({
  components: {
    TextField,
    InputNumber,
    Table,
  },
  props: {
    itemData: {
      type: Array,
      default: [],
    },
    normaltablesearch: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    let List: any = ref([]);

    onMounted(() => {
      List.value = props.itemData;
      processResponse();
      // emit("Taxval", sum(List.value));
    });

    watch(
      () => props.itemData,
      (newVal) => {
        debugger;

        List.value = newVal;
        processResponse();
        // emit("Taxval", sum(List.value));
      }
    );

    const headers = [
      {
        header: "HSN #",
        field: "HSNCode",
        slot: "HSNCode",
        fieldDisplay: "false",
      },
      {
        header: "Tax Type",
        field: "TaxType",
      },
      // {
      //   header: "Tax %",
      //   field: "TaxPer",
      // },
      {
        header: "Tax %",
        field: "CommonTaxPer",
      },

      {
        header: "Tax Amount",
        field: "TaxAmt",
      },
    ];

    const processedData = ref([]);

    // Function to avoid duplicates and sum values
    const processResponse = () => {
      const groupedData = {};

      List.value.forEach((item) => {
        const key = `${item.HSNCode}-${item.HSNId}-${item.TaxType}`;

        if (!groupedData[key]) {
          groupedData[key] = { ...item };
        } else {
          groupedData[key].TaxPer += item.TaxPer;
          groupedData[key].TaxAmt += item.TaxAmt;
        }
      });

      processedData.value = Object.values(groupedData);
    };

    // Watch for changes in responseData and trigger the processing function

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    };

    function sum(data) {
      let addtax = 0;
      data.map((i1) => {
        addtax = addtax + Number(i1.TaxAmt);
      });

      return addtax;
    }

    return {
      processedData,
      headers,
      List,
      globalFilterFields,
      filters,
      sum,
    };
  },
});
</script>

<style></style>
